import request from '@/plugin/axios'

export function page(query) {
    return request({
        url: '/api/case/czBankInfo/page',
        method: 'get',
        params: query
    })
}

export function addObj(obj) {
    return request({
        url: '/api/case/czBankInfo',
        method: 'post',
        data: obj
    })
}

export function getObj(id) {
    return request({
        url: '/api/case/czBankInfo/' + id,
        method: 'get'
    })
}

export function delObj(id) {
    return request({
        url: '/api/case/czBankInfo/' + id,
        method: 'delete'
    })
}

export function putObj(id, obj) {
    return request({
        url: '/api/case/czBankInfo/' + id,
        method: 'put',
        data: obj
    })
}
